import { render, staticRenderFns } from "./SearchBoxDesktop.vue?vue&type=template&id=284e3b95&"
import script from "./SearchBoxDesktop.vue?vue&type=script&lang=js&"
export * from "./SearchBoxDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports